let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iwW79")).then(() => parcelRequire('8zm0a'));